function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "bike");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-3",
  transform: "translate(-85.000000, -110.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "ic_directions_bike_24px",
  transform: "translate(85.500000, 108.500000)"
}, React.createElement("path", {
  d: "M16.1458333,5.72916667 C17.2916667,5.72916667 18.2291667,4.79166667 18.2291667,3.64583333 C18.2291667,2.5 17.2916667,1.5625 16.1458333,1.5625 C15,1.5625 14.0625,2.5 14.0625,3.64583333 C14.0625,4.79166667 15,5.72916667 16.1458333,5.72916667 Z M5.20833333,12.5 C2.29166667,12.5 0,14.7916667 0,17.7083333 C0,20.625 2.29166667,22.9166667 5.20833333,22.9166667 C8.125,22.9166667 10.4166667,20.625 10.4166667,17.7083333 C10.4166667,14.7916667 8.125,12.5 5.20833333,12.5 Z M5.20833333,21.3541667 C3.22916667,21.3541667 1.5625,19.6875 1.5625,17.7083333 C1.5625,15.7291667 3.22916667,14.0625 5.20833333,14.0625 C7.1875,14.0625 8.85416667,15.7291667 8.85416667,17.7083333 C8.85416667,19.6875 7.1875,21.3541667 5.20833333,21.3541667 Z M11.25,10.9375 L13.75,8.4375 L14.5833333,9.27083333 C15.9375,10.625 17.7083333,11.4583333 19.8958333,11.4583333 L19.8958333,9.375 C18.3333333,9.375 17.0833333,8.75 16.1458333,7.8125 L14.1666667,5.83333333 C13.6458333,5.41666667 13.125,5.20833333 12.5,5.20833333 C11.875,5.20833333 11.3541667,5.41666667 11.0416667,5.83333333 L8.125,8.75 C7.70833333,9.16666667 7.5,9.6875 7.5,10.2083333 C7.5,10.8333333 7.70833333,11.3541667 8.125,11.6666667 L11.4583333,14.5833333 L11.4583333,19.7916667 L13.5416667,19.7916667 L13.5416667,13.3333333 L11.25,10.9375 Z M19.7916667,12.5 C16.875,12.5 14.5833333,14.7916667 14.5833333,17.7083333 C14.5833333,20.625 16.875,22.9166667 19.7916667,22.9166667 C22.7083333,22.9166667 25,20.625 25,17.7083333 C25,14.7916667 22.7083333,12.5 19.7916667,12.5 Z M19.7916667,21.3541667 C17.8125,21.3541667 16.1458333,19.6875 16.1458333,17.7083333 C16.1458333,15.7291667 17.8125,14.0625 19.7916667,14.0625 C21.7708333,14.0625 23.4375,15.7291667 23.4375,17.7083333 C23.4375,19.6875 21.7708333,21.3541667 19.7916667,21.3541667 Z",
  id: "bike"
}))));

var SvgBike = function SvgBike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bike.66f6504a.svg";
export { ForwardRef as ReactComponent };